"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TeachingPopoverFooter", {
    enumerable: true,
    get: function() {
        return TeachingPopoverFooter;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useTeachingPopoverFooter = require("./useTeachingPopoverFooter");
const _renderTeachingPopoverFooter = require("./renderTeachingPopoverFooter");
const _useTeachingPopoverFooterStylesstyles = require("./useTeachingPopoverFooterStyles.styles");
const TeachingPopoverFooter = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useTeachingPopoverFooter.useTeachingPopoverFooter_unstable)(props, ref);
    (0, _useTeachingPopoverFooterStylesstyles.useTeachingPopoverFooterStyles_unstable)(state);
    return (0, _renderTeachingPopoverFooter.renderTeachingPopoverFooter_unstable)(state);
});
TeachingPopoverFooter.displayName = 'TeachingPopoverFooter';
